import jQueryInstance from "jquery";
import * as jVectorMapNext from "jvectormap-next";
import jVectorWorldMill from "jvectormap-content/world-mill";

if (
  typeof jVectorMapNext !== "object" ||
  !("initializeJVectorMap" in jVectorMapNext) ||
  typeof jVectorMapNext.initializeJVectorMap !== "function" ||
  !("initializeJVectorMapBundledJQueryMouseWheelPlugin" in jVectorMapNext) ||
  typeof jVectorMapNext.initializeJVectorMapBundledJQueryMouseWheelPlugin !==
    "function"
) {
  throw new Error(
    "Export of jvectormap-next contains an unexpected structure. " +
      "Expected the package to export a object with a two functions, called " +
      "initializeJVectorMap and initializeJVectorMapBundledJQueryMouseWheelPlugin. " +
      "Did you forget to apply the custom compile-time patches?"
  );
}

jVectorMapNext.initializeJVectorMapBundledJQueryMouseWheelPlugin(
  jQueryInstance
);
jVectorMapNext.initializeJVectorMap(jQueryInstance);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
jQueryInstance.fn.vectorMap("addMap", "world_mill", jVectorWorldMill);

export const initializeVectorMap = (
  mapRootElement: HTMLElement,
  vectorMapOptions: unknown
) => {
  const jQueryWrappedVectorMap = jQueryInstance(mapRootElement);

  if (
    !("vectorMap" in jQueryWrappedVectorMap) ||
    typeof jQueryWrappedVectorMap.vectorMap !== "function"
  ) {
    throw new Error(
      "vectorMap function is missing on jQuery wrapped vector map root element."
    );
  }

  jQueryWrappedVectorMap.vectorMap(vectorMapOptions);
};
